import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditQRCodeModal from '../../Modals/QRCode/EditQRCodeModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';
import defaultBrandedImage from 'appSrc/assets/img/v2.svg';
import sampleQRImage from 'appSrc/assets/img/qrcode.png';
import QRCodeStyling from 'qr-code-styling';
import { tdcDomainMatch } from 'appSrc/utils/random';

class AllQRCodesTable extends PureComponent {
    
    constructor( props ) {

        super( props );
        this.state = {
            qrCodeInEdit: null,
            qrCodeInEditIndex: -1,
        };
        this.qrCodeData;
        //this.myRefs = this.props.qrCodes.map(() => createRef());

    }

    downloadQRCode = (data) => {
        this.qrCodeData = new QRCodeStyling({
            data: `${tdcDomainMatch()}/qr/dynamic/${data.id}`,
            image: data.branded_image ? `${data.branded_image}?${Date.now()}` : defaultBrandedImage,
            width: 1000,
            height: 1000,
            dotsOptions: {
                color: '#000',
                type: 'square',
            },
            imageOptions: {
              crossOrigin: 'anonymous',
              margin: 5,
              imageSize: 0.5,
            },
        });

        this.qrCodeData.download({
            name: data.name.replace(/[^a-zA-Z ]/g, ''),
            extension: 'jpeg',
        });
    }

    updateQrCode =( index, id, data ) => {
        this.props.updateQRCode( id, data )
        .then( ( brand ) => {
            return this.props.onBrandUpdated && this.props.onBrandUpdated( index, brand );
        } );
    }

    openEditModal = ( index, qrCode ) => {
        this.setState( { qrCodeInEdit: qrCode, qrCodeInEditIndex: index } );
    }
    
    onEditSubmit = ( brand ) => {
        var index = this.state.qrCodeInEditIndex;
        this.props.onQRCodeUpdated( index, brand );
        this.setState( { qrCodeInEdit: null, qrCodeInEditIndex: -1 } );
    }

    onEditClose = () => {
        this.setState( { qrCodeInEdit: null, qrCodeInEditIndex: -1 } );
    }

    render() {
        const { qrCodes } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( qrCodes ) }
                </InfiniteTable>
                { this.state.qrCodeInEdit &&
                    <EditQRCodeModal 
                    closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    qrCode={ this.state.qrCodeInEdit }
                    downloadQRCode={ this.downloadQRCode } />
                }
            </div>
        );
    }

    rowQr(data, index) {
        const rowQr = new QRCodeStyling({
            data: `${tdcDomainMatch()}/qr/dynamic/${data.id}`,
            image: data.branded_image ? `${data.branded_image}?${Date.now()}` : defaultBrandedImage,
            width: 50,
            height: 50,
            dotsOptions: {
                color: '#000',
                type: 'square',
            },
            imageOptions: {
              crossOrigin: 'anonymous',
              margin: 5,
              imageSize: 0.5,
            },
        });
        
        rowQr.append(this.myRefs[index].current);
    }

    arrayTableRows = ( qrCodes ) => {
        let rows = qrCodes.map( ( qrCode, index ) => {
            
            let individualSlug = `/admin/qr_codes/${ qrCode.id }`;
            //this.rowQr(qrCode, index);

            return (
                <InfiniteTable.Row key={ qrCode.id } className='dl-table-body'>
                    {/* <InfiniteTable.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <div ref={this.myRefs[index]} />
                        <img src={ sampleQRImage } />
                    </InfiniteTable.Cell> */}
                    <InfiniteTable.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ qrCode.branded_image || defaultBrandedImage } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.title }>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ qrCode.name }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ qrCode.description }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { qrCode.deactivated == true ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Download'
                            onClick={ () => {
                                this.downloadQRCode( qrCode );
                            } }/>
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, qrCode );
                            } }/>
                            <DLMenu.Item text={ !qrCode.deactivated ? 'Deactivate' : 'Activate' }
                            onClick={ () => {
                                this.updateQrCode( index, qrCode.id, {
                                    deactivated: !qrCode.deactivated,
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };

        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                {/* <InfiniteTable.Cell></InfiniteTable.Cell> */}
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    NAME { sortIcon( 'name,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    DESCRIPTION { sortIcon( 'description,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    DEACTIVATED { sortIcon( 'deactivated,id,name' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}

AllQRCodesTable.defaultProps = {
    onBrandUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateBrand: ( id, data ) => {
            return dAPI.patch( `/admin/brands/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllQRCodesTable );
